import React from 'react';
import { animated } from '@react-spring/web';
import { useTestableSpring } from '../module-overrides/react-spring';

interface FadeAnimationProps {
  // You can control when animation is triggered with the show prop
  show: boolean;
  onAnimate?: () => void;
  delay?: number;
  children?: React.ReactNode;
}

const ControlledFadeAnimation: React.FunctionComponent<FadeAnimationProps> = ({
  show,
  onAnimate,
  children,
  delay
}) => {
  const style = useTestableSpring({
    to: {
      opacity: show ? 1 : 0,
      height: show ? 'auto' : 0
    },
    delay,
    onChange: onAnimate
  });
  return <animated.div style={style}>{children}</animated.div>;
};

export default ControlledFadeAnimation;
